import {
  Component,
  AfterViewInit,
  Input,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  OnDestroy,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import { MDCTabBarScroller, MDCTabBar } from '@material/tabs';
import { Subject } from 'rxjs/Subject';
import { startWith, tap, takeUntil } from 'rxjs/operators';
import { ISession } from '../../models/session';

export interface ITab {
  name: string;
}

export interface IAction {
  name: string;
  exec: Function;
  color: 'primary' | 'secondary' | 'warning' | 'danger' | 'info';
}

@Component({
  selector: 'tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements AfterViewInit, OnDestroy {
  componentDestroyed$: Subject<boolean> = new Subject();
  @Input() tabs: ITab[];
  @Input() indicator: boolean = false;
  @Input() actions: IAction[] = [];
  @Input() showActions: boolean = true;
  @Input() topTemplate: TemplateRef<any>;
  @Input() session: ISession;
  @Input() diplayLiveMode: boolean = false;
  @Output() onTabChange = new EventEmitter<{}>();
  @Output() multiplicatorChange: EventEmitter<number> = new EventEmitter();

  @ViewChild('children') children: ElementRef;
  @ViewChild('container', { read: ViewContainerRef })
  _vcr: ViewContainerRef;

  public id = `tab-${new Date().getUTCMilliseconds()}`;
  public selectedIndex = 0;

  private tabs$ = new Subject();
  scrollerState = 'right';

  setScroller(state: 'left' | 'right') {
    this.scrollerState = state;
  }

  hideScroller(state: 'left' | 'right') {
    return this.tabs.length > 2 && state !== this.scrollerState;
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
    this.onTabChange.complete();
  }

  ngOnInit() {}

  ngAfterViewInit() {
    const tabBar = new MDCTabBarScroller(
      document.getElementById(this.id),
      undefined,
      el => new MDCTabBar(el)
    );
    this.updateTabList();
    setTimeout(() => {
      if (this.topTemplate) {
        this._vcr.createEmbeddedView(this.topTemplate);
      }
    });
  }

  updateTabList() {
    const childrenAsArray = () => Array.from(this.children.nativeElement.children);
    const addClass = (element: HTMLElement) => element.classList.add('animated', 'fadeIn');
    const showHide = (i: number, index: number, element: HTMLElement) =>
      (element.style.display = i === index ? 'block' : 'none');
    childrenAsArray().forEach(addClass);

    const updateVisibility$ = tap((i: number) =>
      childrenAsArray().forEach((element: HTMLElement, index) => showHide(i, index, element))
    );

    const source$ = this.tabs$
      .pipe(
        startWith(0),
        takeUntil(this.componentDestroyed$),
        updateVisibility$
      )
      .subscribe();
  }

  changeTab(index) {
    this.tabs$.next(index);
    this.onTabChange.emit(this.tabs[index]);
  }

  onMultiplicatorChange(multiplicator: number) {
    this.multiplicatorChange.emit(multiplicator);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/tabs/tabs.component.ts